import { fonts } from './tokens';

// Linear-inspired scale — refined, tight
export const typography = {
    fontFamily: fonts.sans,
    fontFamilyMono: fonts.mono,

    h1: { fontSize: '2rem',     fontWeight: 700, letterSpacing: '-0.03em', lineHeight: 1.2 },
    h2: { fontSize: '1.5rem',   fontWeight: 600, letterSpacing: '-0.02em', lineHeight: 1.25 },
    h3: { fontSize: '1.25rem',  fontWeight: 600, letterSpacing: '-0.02em', lineHeight: 1.3 },
    h4: { fontSize: '1.125rem', fontWeight: 600, letterSpacing: '-0.01em', lineHeight: 1.35 },
    h5: { fontSize: '1rem',     fontWeight: 600, letterSpacing: '-0.01em', lineHeight: 1.4 },
    h6: { fontSize: '0.75rem',  fontWeight: 600, letterSpacing: '0.08em',  lineHeight: 1.4, textTransform: 'uppercase' },

    body1:    { fontSize: '0.9375rem', fontWeight: 400, lineHeight: 1.6,  letterSpacing: '-0.005em' },
    body2:    { fontSize: '0.875rem',  fontWeight: 400, lineHeight: 1.55, letterSpacing: '-0.005em' },
    caption:  { fontSize: '0.75rem',   fontWeight: 500, lineHeight: 1.4 },
    overline: { fontSize: '0.6875rem', fontWeight: 600, lineHeight: 1.4,  letterSpacing: '0.08em', textTransform: 'uppercase' },

    button: { fontSize: '0.875rem', fontWeight: 500, letterSpacing: 0, textTransform: 'none' },
};
